<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->
<template>
  <div>
    <v-layout row>
      <v-flex class="xs12 sm12 lg12">
      </v-flex>
    </v-layout>
    <!--    <div class="tab-content">-->
    <!--&lt;!&ndash;      <view_selector></view_selector>&ndash;&gt;-->
    <!--      <div class="tab-pane active white" id="1pmc-graphs">-->
    <v-container
      fluid
      v-if="
        $store.state.tradeData.report_selection ===
          $store.state.tradeData.report_selections[0]['value']
      "
    >
      <v-layout class="justify-space-around align-center black--text" row>
        <v-flex class="xs12 sm12 md12 lg4 xl4">
          <Hist_impexpgraph_tm_1pmc
            class="d-flex justify-center"
          ></Hist_impexpgraph_tm_1pmc>
        </v-flex>

        <v-flex class="pa-2 xs12 sm12 md12 lg4 xl4">
          <Hist_impexpgraph_tm_total_1pmc
            class="d-flex justify-center"
          ></Hist_impexpgraph_tm_total_1pmc>
        </v-flex>

        <v-flex class="pa-2 xs12 sm12 md12 lg4 xl4">
          <total_imports_exports_1pmc
            class="d-flex justify-center"
          ></total_imports_exports_1pmc>
        </v-flex>
      </v-layout>

      <v-layout
        class="justify-space-around align-center mt-5"
        row
        v-if="$store.state.tradeData.trade_data_cube"
      >
        <v-flex class="pa-1 xs12 sm12 md12 lg4 xl4">
          <trade_deficit_1pmc class="d-flex justify-center"></trade_deficit_1pmc>
        </v-flex>

        <v-flex class="pa-2 xs12 sm12 md12 lg4 xl4">
          <top6Graph_1pmc class="d-flex justify-center"></top6Graph_1pmc>
        </v-flex>

        <v-flex class="pa-2 xs12 sm12 md12 lg4 xl4">
          <export_trends_1pmc
            v-if="
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
                'top6_export_trends'
              ] !== null
            "
            class="d-flex justify-center"
          ></export_trends_1pmc>
        </v-flex>
        <!--             <v-flex class="xs12 sm12 lg12 ml-5 mr-8 mb-9 mt-12">-->
        <!--                    <reoFrontendTable cube_name="cube"></reoFrontendTable>-->
        <!--                  </v-flex>-->
      </v-layout>
    </v-container>

    <!--        second one-->\
    <!--        <abs_summaries></abs_summaries>-->
  </div>
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>
import total_imports_exports_1pmc from '@/components/trade-dsm-application/graphs/1pmc/total-imports-exports-1pmc';
import Hist_impexpgraph_tm_1pmc from '@/components/trade-dsm-application/graphs/1pmc/hist-impexpgraph-tm-1pmc';
import Hist_impexpgraph_tm_total_1pmc from '@/components/trade-dsm-application/graphs/1pmc/hist-impexp-graph-tm-total-1pmc';
import top6Graph_1pmc from '@/components/trade-dsm-application/graphs/1pmc/top6-graph-1pmc';
import trade_deficit_1pmc from '@/components/trade-dsm-application/graphs/1pmc/trade-deficit-1pmc';
import export_trends_1pmc from '@/components/trade-dsm-application/graphs/1pmc/export-trends-1pmc';
// import view_selector from '@/components/trade_data/abs_graphs/view_selector';
// import abs_summaries from '@/components/trade_data/abs_graphs/abs_summaries';
// import ReoFrontendTable from "@/components/trade-dsm-application/result-components/reo_table/reo-frontend-table";
// import helpLink from "@/components/application-level/help-system/help-link";

export default {
  name: 'DSM1PMCGraphs',
  data: () => ({}),

  components: {
    Hist_impexpgraph_tm_1pmc,
    Hist_impexpgraph_tm_total_1pmc,
    total_imports_exports_1pmc,
    top6Graph_1pmc,
    trade_deficit_1pmc,
    export_trends_1pmc,
    // view_selector,
    // abs_summaries,
    // ReoFrontendTable,
    // helpLink
  },
};
</script>

<style scoped>
.iconPM {
  animation: blink 3s ease-in infinite;
}

@keyframes blink {
  from,
  to {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
